import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import InputField from "components/fields/InputField";
import Modal from "components/modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { editUsers } from "store/userSlice";

function UpdatePassword({ isOpen, setIsOpen }) {
  const dispatch = useDispatch();
  const { editLoading } = useSelector((state) => state.users);
  const { userInfo } = useSelector((state) => state.auth);

  const closeModal = () => {
    reset();
    setIsOpen(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: { newPassword: "" },
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      const response = await dispatch(
        editUsers({ _id: userInfo._id, password: data.newPassword })
      );
      if (
        response?.payload?.statuscode === 200 ||
        response?.payload?.statuscode === 201
      ) {
        closeModal();
      } else {
        console.error(
          "Password update failed:",
          response?.msg || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Password update failed:", error);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-[400px]">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Update Password
        </h2>

        <div className="mt-5 w-full max-w-4xl flex-col items-center lg:pl-0">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="mx-auto grid w-full grid-cols-1 gap-4"
            noValidate
          >
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              <InputField
                id="newPassword"
                variant="auth"
                label="New Password*"
                placeholder="Enter new password"
                type="password"
                autoComplete="new-password"
                error={errors.newPassword}
                {...register("newPassword", {
                  required: "New password is required",
                  minLength: {
                    value: 8,
                    message: "At least 8 characters required",
                  },
                })}
              />
            </div>

            <div className="flex items-center justify-end gap-2 pt-2">
              <Button type="button" variant="outline" onClick={closeModal}>
                Cancel
              </Button>

              <LoaderButton type="submit" isLoading={editLoading}>
                Update
              </LoaderButton>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default UpdatePassword;
